import React, { PropsWithChildren } from 'react'
import { Responsive, WidthProvider } from 'react-grid-layout'
import { useGridIsSelectDisabled, useGridLayout, useGridParams } from './GridLayout.hooks'
import classes from './GridLayout.module.scss'
import clsx from 'clsx'

export type GridLayoutProps = PropsWithChildren<{
  className?: string
}>

export const GridHandleClass = 'GridHandle'
export const GridDraggableCancelClass = 'GridDraggableCancel'

export const GridLayout = ({ children, ...props }: GridLayoutProps) => {
  const ResponsiveGridLayout = React.useMemo(() => WidthProvider(Responsive), [])
  const [layouts, setLayouts] = useGridLayout()
  const gridParams = useGridParams()

  const { isSelectDisabled, ...selectDisabledProps } = useGridIsSelectDisabled()

  const className = clsx(props.className, {
    [classes.DisableSelect]: isSelectDisabled,
  })

  return (
    <ResponsiveGridLayout
      {...selectDisabledProps}
      {...gridParams}
      className={className}
      layouts={layouts}
      allowOverlap={false}
      isResizable
      draggableCancel={`.${GridDraggableCancelClass}`}
      draggableHandle={`.${GridHandleClass}`}
      resizeHandle={<div className={classes.handle} />}
      onLayoutChange={(_, layouts) => setLayouts(layouts)}
      margin={[8, 8]}
    >
      {children}
    </ResponsiveGridLayout>
  )
}
